import React from 'react';

import './users-list-page.scss';
import UsersList from 'features/users/components/users-list/users-list';

/**
 * Describe component here
 * @param props
 */
const UsersListPage = () => {

  return <div className={'users-list-page'}>
    <UsersList />
  </div>;
};

export default UsersListPage;
